@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

$loading-spinner-size-profiles: (
  xs: (
    size: 24px,
    line-weight: 4px,
    muted-weight: 2px,
    font-size: 11px
  ),
  sm: (
    size: 40px,
    line-weight: 5px,
    muted-weight: 3px,
    font-size: 12px
  ),
  md: (
    size: 56px,
    line-weight: 6px,
    muted-weight: 3px,
    font-size: 14px
  ),
  lg: (
    size: 72px,
    line-weight: 7px,
    muted-weight: 4px,
    font-size: 16px
  ),
  xl: (
    size: 88px,
    line-weight: 8px,
    muted-weight: 4px,
    font-size: 18px
  )
);

// ================================================================ //
// -- Mixins

@mixin loading-spinner-sizes {
  @each $name, $profile in $loading-spinner-size-profiles {

    &.circle-#{$name} {
      width: map-get($profile, size);
      height: map-get($profile, size);

      & ~ .loading-message {
        font-size: map-get($profile, font-size);
        margin-top: 0.75em;
      }

      .path {
        border-width: map-get($profile, line-weight);

        &.muted {
          border-width: map-get($profile, muted-weight);
        }
      }
    }
  }
}

@mixin loading-spinner-vertical-padding {
  @each $key, $value in $spacing-sizes {
    &.padding-#{$key} {
      padding-top: $value;
      padding-bottom: $value;
    }
  }
}

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-loading-spinner {

    // ==== Loading Spinner Container

    .spinner-container {
      padding-top: 1em;
      padding-bottom: 1em;

      @include loading-spinner-vertical-padding;
    }

    // ==== Spinner Common Styles

    .notched-circle,
    .clipped-circle {
      display: inline-block;
      position: relative;

      @include loading-spinner-sizes;

      &.centered {
        display: block;
        margin: 0 auto;
      }
    }

    // ==== Inner Lines

    .path {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-style: solid;
      border-radius: 50%;
      transform-origin: center;
      will-change: transform;
    }

    // ==== Notched Circle Spinner

    .notched-circle {
      .path {
        border-color: transparent;
        border-top-color: var(--notched-border-color);
        animation: loading-spinner-rotation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

        &.muted {
          border-top-color: $liberty-gray-29;
        }

        &:nth-child(1) {
          animation-delay: -0.45s;
        }

        &:nth-child(2) {
          animation-delay: -0.3s;
        }

        &:nth-child(3) {
          animation-delay: -0.15s;
        }
      }
    }

    // ==== Clipped Circle Spinner

    .clipped-circle {
      .path {
        border-color: var(--clipped-border-color);
        animation: loading-spinner-rotation 1.5s cubic-bezier(0.5, 0, 0.5, 1) infinite;

        &.muted {
          border-color: $liberty-gray-29 $liberty-gray-10;
        }
      }
    }

    // ==== Loading Message

    .loading-message {
      display: block;
      color: var(--message-color);
      font-weight: $font-weight-bold;

      &.centered {
        text-align: center;
      }
    }

    // ==== BlockingLoader Container

    .loader-container {
      position: relative;
    }

    // ==== Translucent Overlay

    .overlay {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      inset: 0;
      background-color: rgba($white, 0.85);
      cursor: progress;

      .loading-message {
        text-align: center;
      }
    }
  }
}

// ================================================================ //
// -- Keyframe Animations

@keyframes loading-spinner-rotation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
